import React, { useEffect, useState } from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal  from "@react/shared/ui/Modal"
import Button from "@react/shared/ui/Button"
library.add(fas)

const KIND_STANDARD = "standard"
const KIND_PROJECT  = "project"

const KIND_LABELS = {
  [KIND_STANDARD]: "navigation.service_quotes",
  [KIND_PROJECT]:  "navigation.project_quotes",
}

const t = key => I18n.t(`crm.opportunities.show.quote_kind.${key}`)

const KindOption = ({ value, checked, onChange }) => (
  <label className="flex items-start gap-3 p-3 rounded-md border border-slate-200 hover:bg-slate-50 cursor-pointer">
    <input
      type      = "radio"
      name      = "kind"
      value     = {value}
      checked   = {checked}
      onChange  = {() => onChange(value)}
      className = "mt-1"
    />
    <div>
      <div className="text-sm font-medium text-slate-900">{I18n.t(KIND_LABELS[value])}</div>
      <div className="text-xs text-slate-500 mt-0.5">{t(`${value}_description`)}</div>
    </div>
  </label>
)

// Both the Devis and Projects modules are on: the user picks the kind of quote.
// Rendered inside the opportunity's create-quote form, so the choice submits with the picked files.
const CreateQuoteButton = ({ buttonClassName }) => {
  const [open, setOpen] = useState(false)
  const [kind, setKind] = useState(KIND_STANDARD)

  useEffect(() => { if (open) setKind(KIND_STANDARD) }, [open])

  const footer = (
    <>
      <div />
      <div className="flex items-center gap-2">
        <Button variant="ghost" onClick={() => setOpen(false)}>{I18n.t("button.cancel")}</Button>
        <Button variant="primary" type="submit">
          {t("confirm")}
          <FontAwesomeIcon icon="arrow-right" />
        </Button>
      </div>
    </>
  )

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className={buttonClassName}>
        <FontAwesomeIcon icon="plus" className="text-[12px]" />
        {I18n.t("crm.opportunities.show.create_quote")}
      </button>
      <Modal
        isOpen  = {open}
        onClose = {() => setOpen(false)}
        eyebrow = {t("eyebrow")}
        title   = {t("title")}
        footer  = {footer}
        size    = "sm"
      >
        <p className="text-sm text-slate-600">{t("intro")}</p>
        <div className="space-y-2">
          <KindOption value={KIND_STANDARD} checked={kind === KIND_STANDARD} onChange={setKind} />
          <KindOption value={KIND_PROJECT}  checked={kind === KIND_PROJECT}  onChange={setKind} />
        </div>
      </Modal>
    </>
  )
}

export default CreateQuoteButton
